/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getBusinessEstablishmentsList = (payload, callback) =>
  req.list(
    c.GET_BUSINESS_EST,
    'api/v1/administrators/business_establishments',
    payload,
    callback
  );

export const getSingleBussEst = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_BUSS_EST,
    `api/v1/administrators/business_establishments/${id}`,
    payload,
    callback
  );

export const createBusinessEst = (payload, callback) =>
  req.create(
    c.CREATE_BUSSINESS_EST,
    'api/v1/administrators/business_establishments',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateBusinessEst = (id, payload, callback) =>
  req.update(
    c.UPDATE_BUSSINESS_EST,
    `api/v1/administrators/business_establishments/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeFixTax = (id, payload, callback) =>
  req.remove(
    c.REMOVE_BUSSINESS_EST,
    `api/v1/administrators/business_establishments/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Remove !');
      if (callback) callback();
    }
  );
